import { IUIUrval } from '../../../../Types/UrvalTypes';
import { IKontodel } from '../Components/KonteringManager/Query/KonteringManagerQuery';
import {
  determineIfIsValueConditionObjectType,
  kontodelInCondition,
} from './kodbehorighetUtils';

export const filterKoddelInSelection = (
  koddel: IKontodel,
  attestKodbehUrval: IUIUrval
): boolean => {
  let isValid: boolean = true;

  for (
    let pageIndex = 0;
    pageIndex < attestKodbehUrval.pages.length;
    pageIndex++
  ) {
    const page = attestKodbehUrval.pages[pageIndex];
    isValid = true;
    for (
      let conditionIndex = 0;
      conditionIndex < page.conditionObjects.length;
      conditionIndex++
    ) {
      const condition = page.conditionObjects[conditionIndex];

      if (
        determineIfIsValueConditionObjectType(condition) &&
        condition.attribute.AttributeName.includes(
          'KONTODEL_' + koddel.ordningsNr.toString()
        )
      ) {
        if (!kontodelInCondition(koddel, condition).isValid) {
          isValid = false;
        }
      }
    }

    if (isValid) {
      return isValid;
    }
  }

  return isValid;
};
